export default function parseJwt(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replaceAll('-', '+').replaceAll('_', '/');
  const jsonEscaped = [...window.atob(base64)]
    .map(c => `%${(`00${c.codePointAt(0).toString(16)}`).slice(-2)}`)
    .join('');
  const jsonPayload = decodeURIComponent(jsonEscaped);

  return JSON.parse(jsonPayload);
}
